var _desc, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0.0000mm",
    y: "0.0000mm",
    width: "26.4580mm",
    height: "26.4580mm",
    viewBox: "0.0000 0.0000 26.4580 26.4580",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TBarCode - 11.17.1.16949") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "BarCode licensed to MEM:TEC-IT Datenverarbeitung GmbH Internal License")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(100%,100%,100%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.458,
    height: 26.458
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2916,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 0,
    width: 1.0583,
    height: 1.0583
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 1.0583,
    width: 1.0583,
    height: 1.0583
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 2.1166,
    width: 1.0583,
    height: 1.0583
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 3.175,
    width: 1.0583,
    height: 1.0583
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 4.2333,
    width: 1.0583,
    height: 1.0583
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 5.2916,
    width: 1.0583,
    height: 1.0583
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2916,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 6.3499,
    width: 1.0583,
    height: 1.0583
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 7.4082,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 7.4082,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 7.4082,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 7.4082,
    width: 1.0583,
    height: 1.0583
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4082,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9914,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 8.4666,
    width: 1.0583,
    height: 1.0583
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4082,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 9.5249,
    width: 1.0583,
    height: 1.0583
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2916,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 10.5832,
    width: 1.0583,
    height: 1.0583
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2916,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9914,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 11.6415,
    width: 1.0583,
    height: 1.0583
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9914,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 12.6998,
    width: 1.0583,
    height: 1.0583
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4082,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 13.7582,
    width: 1.0583,
    height: 1.0583
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 14.8165,
    width: 1.0583,
    height: 1.0583
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4082,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 15.8748,
    width: 1.0583,
    height: 1.0583
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4082,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9914,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 16.9331,
    width: 1.0583,
    height: 1.0583
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 17.9914,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 17.9914,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 17.9914,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 17.9914,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 17.9914,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 17.9914,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 17.9914,
    width: 1.0583,
    height: 1.0583
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2916,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 19.0498,
    width: 1.0583,
    height: 1.0583
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 20.1081,
    width: 1.0583,
    height: 1.0583
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9914,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 21.1664,
    width: 1.0583,
    height: 1.0583
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9914,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 22.2247,
    width: 1.0583,
    height: 1.0583
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9914,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 23.283,
    width: 1.0583,
    height: 1.0583
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5832,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6998,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8748,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9331,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0498,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 24.3414,
    width: 1.0583,
    height: 1.0583
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%,0%,0%)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.0583,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1166,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.175,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2333,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2916,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3499,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4666,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5249,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6415,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7582,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8165,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1081,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1664,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2247,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.283,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3414,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3997,
    y: 25.3997,
    width: 1.0583,
    height: 1.0583
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.cad66b44b26d824bba6301ee3af17919.svg";
export { ForwardRef as ReactComponent };